import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * Manual Sliced PDF Engine (T-TradeSketch-017)
 * 
 * Captures each .page-break element individually to ensure 1:1 parity 
 * between the report preview and the final PDF.
 */
export const exportReportToPDF = async (
  element: HTMLElement | null,
  fileName: string = 'Report'
) => {
  if (!element) {
    console.error("Missing report element for PDF export");
    throw new Error("Missing report element");
  }

  const pages = Array.from(element.querySelectorAll('.page-break')) as HTMLElement[];
  if (pages.length === 0) {
    console.warn("No .page-break elements found, capturing root element instead");
    pages.push(element);
  }

  console.log(`Initiating manual slicing export for ${pages.length} pages:`, fileName);

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
    compress: true
  });

  const canvasOptions = {
    scale: 2, // High resolution
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    width: 794,  // A4 width at 96 DPI
    height: 1123 // A4 height at 96 DPI
  };

  for (let i = 0; i < pages.length; i++) {
    const page = pages[i];
    console.log(`Capturing page ${i + 1}/${pages.length}...`);
    
    const canvas = await html2canvas(page, canvasOptions);
    const imgData = canvas.toDataURL('image/jpeg', 0.95);
    
    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297);
  }

  console.log('Saving PDF:', fileName);
  pdf.save(`${fileName}.pdf`);
};
